import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'wix-style-react';
import { ServicesProvider } from '@wix/experts-common';
import { PageWidthBreakPoint } from '../../../../utils/constants';
import PortfolioItem from '../../../common/PortfolioItem/PortfolioItem';
import s from './ExpertDataProjects.scss';
import isServer from '../../../../utils/isServer';

class ProfilePortfolio extends Component {
  static propTypes = {
    projects: PropTypes.array,
    showMoreProjects: PropTypes.bool,
    expertGuid: PropTypes.string,
    staticsBaseUrl: PropTypes.string,
  };

  static defaultProps = {
    showMoreProjects: true,
  };

  componentDidUpdate(prevProps) {
    if (!this.props.showMoreProjects) {
      const elem = document.querySelector('#more-projects-container > div');
      elem && elem.focus();
    }
  }

  displayProjects = (projects, staticsBaseUrl, addToIndex = 0) =>
    projects.map((project, index) => (
      <PortfolioItem
        className={s.projectItemContainer}
        key={index + addToIndex}
        siteName={project.siteName}
        description={project.description}
        siteUrl={project.siteUrl}
        uploadImage={project.uploadImage}
        thumbnail={project.thumbnail}
        imgDimensions={{ w: 466, h: 285 }}
        expertGuid={this.props.expertGuid}
        siteLocationId={index + addToIndex}
        origin="expert profile"
        metaSiteId={project.metaSiteId}
        staticsBaseUrl={staticsBaseUrl}
      />
    ));

  render() {
    const { projects, showMoreProjects, staticsBaseUrl } = this.props;
    const isTabletOrDesktop = isServer
      ? !this.context.services.isMobile
      : window.matchMedia(PageWidthBreakPoint.Width_Tablet).matches;
    const numOfProjectsToDisplayInARow = isServer
      ? 4
      : window.matchMedia(PageWidthBreakPoint.Width_1024).matches
      ? window.matchMedia(PageWidthBreakPoint.Width_1280).matches
        ? 4
        : 3
      : 4;

    return (
      <div>
        {isTabletOrDesktop ? (
          <div>
            <div className={s.projectsContainer} data-hook="projects-container">
              {this.displayProjects(
                projects.slice(0, numOfProjectsToDisplayInARow),
                staticsBaseUrl,
              )}
            </div>
            <Collapse className={s.projectsContainer} open={!showMoreProjects}>
              <div
                className={s.projectsContainer}
                id="more-projects-container"
                data-hook="more-projects-container"
              >
                {this.displayProjects(
                  projects.slice(numOfProjectsToDisplayInARow),
                  staticsBaseUrl,
                )}
                <div
                  className={`${s.projectItemContainer} ${s.emptyProjectItemContainerFixingFlexWrapspaceBetweenLayout}`}
                />
                <div
                  className={`${s.projectItemContainer} ${s.emptyProjectItemContainerFixingFlexWrapspaceBetweenLayout}`}
                />
              </div>
            </Collapse>
          </div>
        ) : (
          <div
            className={s.projectsContainer}
            data-hook="projects-container-horizontal"
          >
            {this.displayProjects(projects, staticsBaseUrl)}
          </div>
        )}
      </div>
    );
  }
}

ProfilePortfolio.contextTypes = ServicesProvider.childContextTypes;
export default ProfilePortfolio;
